import { Tag } from "antd";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { useAppSelector } from "@/store";
import { OUTSTANDING, CLOSED, ACTIVE, INACTIVE } from "@/enums/pageEnum";

const Status = ({ status }: { status: string }) => {
  const { t } = useTranslation();
  const darkMode = useAppSelector((state) => state.app.theme);
  const tagColor = useMemo(() => {
    switch (status) {
      case "CLEAR":
      case "COMPLETE":
      case "SUBMITTED":
      case "COLLECTED":
        return "bg-[#359c021a] text-[#359C02]";
      case "PENDING_REVIEW":
      case "DISPATCHED":
        return "bg-[#faad141a] text-[#D48806]";
      case "CANCELLED":
        return "bg-[#d1273014] text-[#D12730]";
      case "DELAY":
        return "bg-[#ff55001a] text-[#FF5500]";
      case "IMMEDIATE":
        return "bg-[#FF55001a] text-[#FF5500]";
      case OUTSTANDING:
      case "Outstanding":
      case "NORMAL":
      case "OPEN":
      case "Open":
        return "bg-[#1890FF1a] text-[#1890FF]";
      case ACTIVE:
      case "Online":
        return "text-[#008000] bg-[#0080001f]";
      case CLOSED:
      case "Closed":
      case "CLOSE":
      case "DISMISSED":
      case INACTIVE:
      case "Offline":
        return darkMode === "dark"
          ? "bg-[#ffffff1f] text-[#ffffffd9]"
          : "bg-[#F0F0F0] text-[#00000073]";
      default:
        return "bg-[#d1273038] text-[#D12730]";
    }
  }, [status, darkMode]);
  return (
    <Tag
      className={clsx("rounded-full leading-6 text-[14px] ml-1", tagColor)}
      bordered={false}
    >
      {t(status || "")}
    </Tag>
  );
};

export default Status;
